<template>
  <div id="app">
    <div class="container">
      <div id="hamburger"><img :src="'images/hamburger.png'"></div>
      <div id="logo">
        <img id="logo-img" :src="'images/logo-info.png'" usemap="#logomap">

        <router-link id="info-link" to="/"></router-link>
        <router-link id="movie-link" to="/film"></router-link>
        <router-link id="movie-link-2" to="/film"></router-link>
        <router-link id="design-link" to="/ontwerp"></router-link>
        <router-link id="design-link-2" to="/ontwerp"></router-link>

      </div>
      <!--<div id="nav">
        <router-link id="xinfo-link" to="/">Info</router-link> |
        <router-link id="xmovie-link" to="/film">Film</router-link> |
        <router-link id="xdesign-link" to="/ontwerp">Ontwerp</router-link>
      </div>-->
      <div class="wall">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
    @font-face {
      font-family: "Nimbus Sans";
      src: url("assets/fonts/nimbus-regular.otf");
    }

    @font-face {
      font-family: "Nimbus Sans";
      src: url("assets/fonts/nimbus-light.otf");
      font-weight: lighter;
    }

    @font-face {
      font-family: "Nimbus Sans";
      src: url("assets/fonts/nimbus-bold.otf");
      font-weight: bold;
    }

    html, body{
      margin: 0;
      font-family: "Nimbus Sans";
      font-size: 3vw;
    }

    h2{
      font-weight: normal;
      margin-bottom: 0;
    }
    p{
      margin-top: 0;
    }

    .container {
      //border: 1px solid green;
      max-width: 960px;
      margin: 20px auto;
    }

    #logo{
      margin-left: 6.25%;
      width: 31.25%;
      margin-bottom: 6.25%;
      position: relative;
    }

    #logo a{
      display: block;
      position: absolute;
    }
    #movie-link{
      top: 0%; left: 0%; width: 60%; height: 60%;
    }
    #movie-link-2{
      top: 0%; left: 60%; width: 20%; height: 20%;
    }
    #design-link{
      top: 20%; left: 40%; width: 40%; height: 60%;
    }
    #design-link-2{
      top: 80%; left: 0%; width: 80%; height: 20%;
    }
    #info-link{
      top: 0%; left: 80%; width: 20%; height: 80%;
    }

    #hamburger{
      margin-right: 6.25%;
      width: 18.75%;
      margin-bottom: 6.25%;
      float: right;
    }

    #logo img, #hamburger img{ width: 100%; }

    .wall{
      display: flex;
      flex-direction: column;
    }

    .poster{
      /*background-color: green;*/
      margin-bottom: 6.25%;
      display: flex;
      position: relative;
    }

    .poster .image{
      /*background-color: blue;*/
      width: 62.5%;
    }
    .image img{
      width: 100%;
    }
    .poster .margin{
      width: 18.75%;
    }
    .poster .caption{
      width: 93.75%;
      transform-origin: 0 0;
      position: absolute;
      top: 0%;
      left: 87.5%;
      transform: rotate(90deg);
      /*background-color: red;*/
      height: 6.25%;
    }

    .film .caption{
      margin-left: 6.25%;
      /*background-color: purple;*/
      width: 87.5%;
    }

    .info .caption{
      margin-left: 6.25%;
      /*background-color: purple;*/
      width: 87.5%;
    }

    @media (min-width: 960px){
      html, body{
        font-size: 24pt;
      }
    }
</style>
<script>
export default {
  watch: {
    '$route' (to, from) {
      document.getElementById('logo-img').src = to.meta.logo
    }
  }
}
</script>
